export default {
  'Something went wrong. Please try again or contact admin for supports.':
    'Something went wrong. Please try again or contact admin for supports.',
  'This user has already been in another institution.':
    'This user has already been in another facility.',
  'Institution code has already been used':
    'Facility code has already been used',
  'Please upload a file less than 1.5MB':
    'Please upload a file less than 1.5MB',
  'Role code has already been used': 'Role code has already been used',
  'Not found role ID': 'Not found role ID',
  'Cannot delete default roles': 'Cannot delete default roles',
  'Role name has already been used': 'Role name has already been used',
  'User name has already been used': 'User name has already been used',
  'Group Account has already been used': 'Group Account has already been used',
  'Not found study ID': 'Not found study ID',
  'Fail to sync match status to studylist':
    'Fail to sync match status to studylist',
  'Procedure group name has already been used':
    'Procedure group name has already been used',
  'Procedure code has already been used':
    'Procedure code has already been used',
  'Body part name has already been used':
    'Body part name has already been used',
  'Department code has already been used':
    'Department code has already been used',
  'Department name has already been used':
    'Department name has already been used',
  'Not found recorded annotation': 'Not found recorded annotation',
  'Fail to update this recorded annotation': 'Fail to update this recorded annotation',
  'Fail to create this recorded annotation': 'Fail to create this recorded annotation',
  'Fail to get the recorded annotations': 'Fail to get the recorded annotations',
  'Wrong owner of this recorded annotation': 'Wrong owner of this recorded annotation',
  'Fail to delete recorded annotation': 'Fail to delete recorded annotation',
  'Not found valid study to perform': 'Not found valid study to perform',
  'Template Report Code already been used':
    'Template Report Code already been used',
  'Patient ID invalid, please choose the same Patient ID':
    'Patient ID invalid, please choose the same Patient ID',
  'Order already been used': 'Order already been used',
  'Not found order ID': 'Not found order ID',
  'Order status is Matched. Please unmatch first.':
    'Order status is Matched. Please unmatch first.',
  'Fail to match order with study.': 'Fail to match order with study.',
  'Fail to unmatch order with study.': 'Fail to unmatch order with study.',
  'Fail to sync order status.': 'Fail to sync order status.',
  'Visit ID already been used. Please fill a different value or leave it blank':
    'Visit Number already been used. Please fill a different value or leave it blank',
  'Order ID already been used. Please fill a different value or leave it blank':
    'Order ID already been used. Please fill a different value or leave it blank',
  'Cannot auto generate ID. Please try again or contact admin for supports':
    'Cannot auto generate ID. Please try again or contact admin for supports',
  'Cannot assign procedures to order. Please fill valid procedures.':
    'Cannot assign procedures to order. Please fill valid procedures.',
  'Cannot assign device to order. Please fill a valid device.':
    'Cannot assign device to order. Please fill a valid device.',
  'Invalid patient ID. Please fill a valid patient ID or leave it blank.':
    'Invalid patient ID. Please fill a valid patient ID or leave it blank.',
  'Fail to receive': 'Fail to receive',
  'Institution mismatch. please choose the same Institution':
    'Facility mismatch. please choose the same Facility',
  'Invalid order status. Please choose status is New/Cancel.':
    'Invalid order status. Please choose status is New/Cancel.',
  'Invalid order status.': 'Invalid order status.',
  'Please choose procedure': 'Please choose procedure',
  'Cannot delete order with status is ARRIVED':
    'Cannot delete order with status is ARRIVED',
  'Layout Report Name already been used':
    'Layout Report Name already been used',
  'Not found layout ID': 'Not found layout ID',
  'Approve all reports before create new':
    'Approve all reports before create new',
  'Not found report': 'Not found report',
  "Invalid report's actions flow": 'Luồng báo cáo không hợp lệ',
  'Another doctor is reading this report':
    'Another doctor is reading this report',
  'Fail to cancel report': 'Fail to cancel report',
  'Device name has already been used': 'Device name has already been used',
  'Fail to share study': 'Fail to share study',
  'Fail to update share study': 'Fail to update share study',
  'Cannot delete expired share study': 'Cannot delete expired share study',
  "Limited study share on a month's":
    'Chia sẻ ca chụp giới hạn trong một tháng',
  'Invalid institution to share study': 'Invalid facility to share study',
  'Filter Name has already been used': 'Filter Name has already been used',
  'Not found filter': 'Not found filter',
  'Fail to create rule CAD': 'Fail to create rule CAD',
  'Fail to update rule CAD': 'Fail to update rule CAD',
  'Fail to delete rule CAD': 'Fail to delete rule CAD',
  'Can not find rule CAD': 'Can not find rule CAD',
  'Can\'t update the request has been marked as either "reading" or "completed"':
    'Can\'t update the request has been marked as either "reading" or "completed"',
  'Can\'t delete the request has been marked as either "reading" or "completed"':
    'Can\'t delete the request has been marked as either "reading" or "completed"',
  'Please choose group account': 'Please choose group account',
  'Please choose account': 'Please choose account',
  'Can not delete all data. Please contact admin for supports.':
    'Can not delete all data. Please contact admin for supports.',
  'Can not create or reset password. Please contact admin for supports.':
    'Can not create or reset password. Please contact admin for supports.',
  'Can not create or reset password. Please update phone number':
    'Can not create or reset password. Please update phone number',
  'Institution ID invalid. Please contact admin for supports':
    'Facility ID invalid. Please contact admin for supports',
  'Fail to create print job': 'Fail to create print job',
  'Please fill value in this field': 'Please fill value in this field',
  'Enter in the format: name@example.com':
    'Enter in the format: name@example.com',
  'At least 10 numbers and allow character +':
    'At least 10 numbers and allow character +',
  'At least 8 characters long': 'At least 8 characters long',
  'The password confirmation does not match':
    'The password confirmation does not match',
  'The password is incorrect': 'The password is incorrect',
  'Are you sure you want to delete institution?':
    'Are you sure you want to delete facility?',
  'Are you sure you want to delete role?':
    'Are you sure you want to delete role?',
  'Are you sure you want to delete user?':
    'Are you sure you want to delete user?',
  'Are you sure you want to delete group account?':
    'Are you sure you want to delete group account?',
  'Are you sure want to unmacth order?': 'Are you sure want to unmacth order?',
  'Are you sure you want to delete procedure group?':
    'Are you sure you want to delete procedure group?',
  'Are you sure you want to delete procedure?':
    'Are you sure you want to delete procedure?',
  'Are you sure you want to delete body part?':
    'Are you sure you want to delete body part?',
  'Are you sure you want to delete department?':
    'Are you sure you want to delete department?',
  'Are you sure want to delete template report?':
    'Are you sure want to delete template report?',
  'Are you sure want to delete order?': 'Are you sure want to delete order?',
  'Are you sure want to delete layout report?':
    'Are you sure want to delete layout report?',
  'This template will overwrite your current work. Do you want to continue?':
    'This template will overwrite your current work. Do you want to continue?',
  'Are you sure want to delete device?': 'Are you sure want to delete device?',
  'Are you sure want to delete share study?':
    'Are you sure want to delete share study?',
  'Are you sure want to delete this filter?':
    'Are you sure want to delete this filter?',
  'Are you sure want to delete this rule CAD?':
    'Are you sure want to delete this rule CAD?',
  'Are you sure want to delete this request?':
    'Are you sure want to delete this request?',
  'Are you sure want to delete patient?':
    'Are you sure want to delete patient?',
  'Are you sure want to reset password?':
    'Are you sure want to reset password?',
  'The institution has been created': 'The facility has been created',
  'The institution has been updated': 'The facility has been updated',
  'The institution has been deleted': 'The facility has been deleted',
  'The role has been created': 'The role has been created',
  'The role has been updated': 'The role has been updated',
  'The role has been deleted': 'The role has been deleted',
  'The account has been created': 'The account has been created',
  'The account has been updated': 'The account has been updated',
  'The account has been deleted': 'The account has been deleted',
  'Group account has been created': 'Group account has been created',
  'Group account has been updated': 'Group account has been updated',
  'Group account has been deleted': 'Group account has been deleted',
  'All orders have been matched': 'All orders have been matched',
  'All orders have been unmatched': 'All orders have been unmatched',
  'The procedure group has been created':
    'The procedure group has been created',
  'The procedure group has been updated':
    'The procedure group has been updated',
  'The procedure group has been deleted':
    'The procedure group has been deleted',
  'The procedure has been created': 'The procedure has been created',
  'The procedure has been updated': 'The procedure has been updated',
  'The procedure has been deleted': 'The procedure has been deleted',
  'The body part has been created': 'The body part has been created',
  'The body part has been updated': 'The body part has been updated',
  'The body part has been deleted': 'The body part has been deleted',
  'The department has been created': 'The department has been created',
  'The department has been updated': 'The department has been updated',
  'The department has been deleted': 'The department has been deleted',
  'The template report has been created':
    'The template report has been created',
  'The template report has been updated':
    'The template report has been updated',
  'The template report has been deleted':
    'The template report has been deleted',
  'The order has been created': 'The order has been created',
  'The order has been updated': 'The order has been updated',
  'The order has been deleted': 'The order has been deleted',
  'You can use this Patient ID': 'You can use this Patient ID',
  'The order has been received': 'The order has been received',
  'The layout report has been created': 'The layout report has been created',
  'The layout report has been updated': 'The layout report has been updated',
  'The layout report has been deleted': 'The layout report has been deleted',
  'The report has been created': 'The report has been created',
  'The report has been updated': 'The report has been updated',
  'The report has been deleted': 'The report has been deleted',
  'The device has been created': 'The device has been created',
  'The device has been updated': 'The device has been updated',
  'The device has been deleted': 'The device has been deleted',
  'This study has been shared': 'This study has been shared',
  'This study share has been updated': 'This study share has been updated',
  'This study share has been deleted': 'This study share has been deleted',
  'The filter has been created': 'The filter has been created',
  'The filter has been updated': 'The filter has been updated',
  'The filter has been deleted': 'The filter has been deleted',
  'The rule CAD has been created': 'The rule CAD has been created',
  'The rule CAD has been updated': 'The rule CAD has been updated',
  'The rule CAD has been deleted': 'The rule CAD has been deleted',
  'This request has been assigned': 'This request has been assigned',
  'This request has been updated': 'This request has been updated',
  'This request has been deleted': 'This request has been deleted',
  'Key image has been created': 'Key image has been created',
  'This data has been deleted': 'This data has been deleted',
  'The patient account has been created':
    'The patient account has been created',
  'The print job has been created': 'The print job has been created',
};
